import { render, staticRenderFns } from "./ConfirmationFailedPage.vue?vue&type=template&id=9e5500d6&scoped=true"
import script from "./ConfirmationFailedPage.vue?vue&type=script&lang=js"
export * from "./ConfirmationFailedPage.vue?vue&type=script&lang=js"
import style0 from "./ConfirmationFailedPage.vue?vue&type=style&index=0&id=9e5500d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e5500d6",
  null
  
)

export default component.exports